const EventFragment = () => ({
  height: 0,

  get style() {
    return {
      '--height': `${this.height}px`
    };
  },

  onResize() {
    this.height = this.$root.getBoundingClientRect().height;
  }
});

export default EventFragment;
